import { Theme } from '@mui/material';
import styled from 'styled-components';

type MarkProps = {
  isActive: boolean,
  isSelected: boolean,
  disabled: boolean,
}

const getHoverColor = (theme: Theme, isActive: boolean, disabled: boolean) => {
  if (disabled) {
    return 'none';
  }
  if (isActive) {
    return theme.palette.primary.dark;
  }
  return theme.palette.backdrop.dark;
};

const Mark = styled.div<MarkProps>`
  width: 48px;
  height: 36px;
  border-radius: ${({ isSelected }) => (isSelected ? '0 24px 24px 0' : '0')};
  background-color: ${({ isActive, theme }) =>
    (isActive ? theme.palette.primary.dark : 'none')};
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ isActive, theme }) =>
    (isActive ? theme.palette.primary.contrastText : theme.palette.backdrop.contrastText)};
  font-weight: ${({ isSelected }) => (isSelected ? 'bold' : 'normal')};;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  &:hover {
    background-color: ${({ isActive, theme, disabled }) =>
    getHoverColor(theme, isActive, disabled)};
  }
`;

const MarksContainer = styled.div`
  display: flex;
  flex-direction: row;
  border-radius: ${({ theme }) => theme.shape.borderRadius * 6}px;
  background-color: ${({ theme }) => theme.palette.backdrop.main};
  overflow: hidden;
  margin-top: ${({ theme }) => theme.spacing(1)};
`;

const ErrorSelect = styled.div`
  margin-top: ${({ theme }) => theme.spacing(2)};
`;

export { ErrorSelect, Mark, MarksContainer };
